import type {TarjetaCola} from '@/lib/bateria-cola'

/** El estado lo decide el servidor (`EstadoTarjeta`); esto solo lo traduce. Verde es humano, ámbar
 * es máquina: una lectura que nadie confirmó nunca se pinta verde. */
export type ChipDeEstado = {
  /** Sufijo de la clave i18n bajo `admin.bateria.cola.estado.`. */
  clave: string
  tono: 'green' | 'amber' | 'neutral'
  /** El punto ámbar: lo pinta lo que salió de una máquina, jamás una decisión humana. */
  puntoDelSistema: boolean
  /** `null` = sin nombre: la copia cae a la variante sin autor. */
  nombre: string | null
}

/** `no_aplica_filtro` gana sobre el estado sin ser un quinto estado: nadie pide ese ítem, pero se
 * puede contestar. */
export function chipDeEstado(tarjeta: TarjetaCola): ChipDeEstado {
  if (tarjeta.no_aplica_filtro === true) {
    return {clave: 'noAplica', tono: 'neutral', puntoDelSistema: false, nombre: null}
  }
  const nombre = tarjeta.decidido_por_nombre ?? null
  if (tarjeta.estado === 'confirmado' || tarjeta.estado === 'corregido') {
    return {
      clave: nombre ? tarjeta.estado : `${tarjeta.estado}SinNombre`,
      tono: 'green',
      puntoDelSistema: false,
      nombre,
    }
  }
  if (tarjeta.estado === 'pendiente') {
    return {clave: 'pendiente', tono: 'amber', puntoDelSistema: false, nombre: null}
  }
  return {clave: 'sinConfirmar', tono: 'neutral', puntoDelSistema: true, nombre: null}
}

/** Punto único que respetan los botones y el teclado de la cola. No bloquea `no_aplica_filtro`:
 * la calificación lo excluye en `bateria_revision.respuestas_para_calificar`. */
export function tarjetaContestable(tarjeta: TarjetaCola | undefined): boolean {
  return tarjeta !== undefined
}

/** `pendiente` sale de los mismos predicados del servidor que cuentan PENDIENTES; acá solo se
 * resta lo que esta sesión ya resolvió. */
export function esPorMarcar(tarjeta: TarjetaCola, resuelta: (ref: string) => boolean): boolean {
  return tarjeta.estado === 'pendiente' && !resuelta(tarjeta.ref)
}

/** Sobre lo cargado, no sobre los totales del servidor: el botón no salta a lo que no llegó. */
export function cuantasPorMarcar(tarjetas: TarjetaCola[], resuelta: (ref: string) => boolean): number {
  return tarjetas.filter((tarjeta) => esPorMarcar(tarjeta, resuelta)).length
}
